import PouchLoadService from "external-services/pouch-load-service/index";
import {WHOLE_NUMBER_REGEX} from "appRoot/app.constants";

const NS = 'CreateLayouts';

const template = require('./createLayouts.html');

export default function CreateLayouts(tablesService, unregister) {
  "ngInject";

  return {
    scope: true,
    bindToController: {
      layouts: '=',
      isDisabled: '=',
      displayErrors: '=',
      checkCount: '='
    },
    controller,
    controllerAs: 'vm',
    restrict: 'E',
    template
  };

  function controller($scope) {
    "ngInject";

    const vm = this;
    var listeners = [];
    var layoutsShow = [];

    //-- define public properties
    vm.shapes = tablesService.shapes;
    vm.availableOptions = tablesService.availableOptions;
    //-- define public methods
    vm.addTable = addTable;
    vm.deleteTable = deleteTable;
    vm.shapeChanged = shapeChanged;
    vm.capacityChanged = capacityChanged;
    vm.showErrors = showErrors;
    vm.layoutNum = 0;
    vm.WHOLE_NUMBER_REGEX = WHOLE_NUMBER_REGEX;

    //-- listen
    listeners.push($scope.$watch('layoutsForm.$valid', validUpdate));
    listeners.push($scope.$watch('vm.layouts.length', validUpdate));
    listeners.push($scope.$watch('vm.layoutNum', updateShow));
    listeners.push($scope.$watch('vm.checkCount', showErrors));
    listeners.push($scope.$on('$destroy', () => unregister(listeners)));

    function addTable(layout) {
      layout.tables.push({
        name: '',
        shared: false,
        capacity: 2,
        minCapacity: 1,
        type: 'table',
        online: true,
        walkinOnly: false,
        availableOption: 'all',
        shapeUpdated: false,
        shape: 'square',
        _id: PouchLoadService.getNewId(['table'])
      });
    }

    function updateShow() {
      var index = layoutsShow.indexOf(vm.layoutNum);
      if (index === -1) {
        layoutsShow.push(vm.layoutNum);
      }
    }

    function shapeChanged(table) {
      table.shapeUpdated = true;
    }

    function capacityChanged(table) {
      if (!table.shapeUpdated) {
        if (table.capacity <= 4) {
          table.shape = 'square';
        } else {
          table.shape = 'rect';
        }
      }
    }

    function deleteTable(layout, table) {
      var index = layout.tables.map(function (e) {
        return e._id;
      }).indexOf(table._id);
      if (index > -1 && table) {
        layout.tables.splice(index, 1);
      }
    }

    function validUpdate() {
      if (vm.layouts && vm.layouts.length && layoutsShow.length === vm.layouts.length) {
        $scope.vm.isDisabled = !$scope.layoutsForm.$valid;
      } else {
        $scope.vm.isDisabled = true;
      }
    }

    function showErrors() {
      if (vm.displayErrors) {
        for (var i = vm.layouts.length - 1; i >= 0; i--) {
          var layout = vm.layouts[i];
          if (!$scope.layoutsForm['layout-' + layout._id]) {
            for (var t = layout.tables.length - 1; t >= 0; t--) {
              var table = layout.tables[t];
              if (!table.priority) {
                vm.layoutNum = i;
                break;
              }
            }
          } else if (!$scope.layoutsForm['layout-' + layout._id].$valid) {
            vm.layoutNum = i;
            break;
          }
        }
      }
    }
  }
}
